import React from 'react';
import { NFL_TEAM_NAMES } from '../constants';
import { TeamRecord } from '../../../shared/types';
import './TeamBreakdown.css';
import { getOwnerColor, getOwnerColorClass } from '../utils/ownerColors';
import { getFantasyTeamName } from '../utils/teamNames';

interface TeamBreakdownProps {
  playerName: string;
  teams: string[];
  teamRecords?: Record<string, TeamRecord>;
}

const TeamBreakdown: React.FC<TeamBreakdownProps> = ({ playerName, teams, teamRecords }) => {
  const ownerClass = getOwnerColorClass(playerName);

  return (
    <div className="team-breakdown">
      <h3>
        <span className={`owner-colored ${ownerClass}`} style={{ color: getOwnerColor(playerName) }}>
          {getFantasyTeamName(playerName)}
        </span>
        {' NFL Teams'}
      </h3>
      <div className="teams-grid">
        {teams.map((teamAbbr) => {
          const record = teamRecords?.[teamAbbr];
          let recordText = '';
          if (record) {
            const segments: string[] = [`${record.regularWins}-${record.regularLosses}-${record.regularTies}`];
            if ((record.playoffWins + record.playoffLosses) > 0) {
              segments.push(`P: ${record.playoffWins}-${record.playoffLosses}`);
            }
            if ((record.playoffByes || 0) > 0) {
              segments.push(`Bye${record.playoffByes === 1 ? '' : 's'}: ${record.playoffByes}`);
            }
            recordText = `(${segments.join(', ')})`;
          }
          return (
            <div key={teamAbbr} className={`team-card ${ownerClass}`}>
              <div className="team-abbr">{teamAbbr}</div>
              <div className="team-name">{NFL_TEAM_NAMES[teamAbbr] || teamAbbr} {recordText}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TeamBreakdown;
